import districtsService from "api/districtsService";
import { useMutation } from "react-query";

import { IAddDistrictBody } from "types/district";

const useAddDistrictMutation = () => {
  return useMutation(async(data: IAddDistrictBody) => {
    try {
      const res = await districtsService.addDistrict(data)

      return res.data
    } catch(err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useAddDistrictMutation